import getFormFile from './getFormFile'

export const getFormFilePromise = getFormFile
